import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';

class TranscriptServices{

  //GET /api/AcademicYear_SemesterAPI/ARG_SelectAcademicYearByStudent
  SelectAcademicYearByStudent(StudentID){
    return axios.get(API_URL + `AcademicYear_SemesterAPI/ARG_SelectAcademicYearByStudent?StudentID=${StudentID}`,
        { headers: authHeader() } )            
  }

  //GET /api/AcademicYear_SemesterAPI/Get_SemesterYeaByYearId
  GetSemesterYeaByYearId(YearID){
    return axios.get(API_URL + `AcademicYear_SemesterAPI/Get_SemesterYeaByYearId?YearID=${YearID}`,
        { headers: authHeader() } )            
  }

}



export default new TranscriptServices();